import * as constants from './constants';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

export function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload };
}

export function getInfoFromToken(hashToken) {
  return { type: constants.PROCESS_HASHTOKEN, payload: { hashToken } }
}

export function clearStore() {
  return { type: constants.CLEAR_STORE  }
}



// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/__storeFiles__/actions.js